"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBytesSize = void 0;
const constants_1 = require("../../constants");
require("../../core");
const getBytesSize = (bytes) => {
    if (bytes === 0) {
        return constants_1.BYTES.sizes[0];
    }
    const sizeIndex = Math.floor(Math.log(bytes) / Math.log(constants_1.BYTES.k));
    return constants_1.BYTES.sizes[sizeIndex];
};
exports.getBytesSize = getBytesSize;
//# sourceMappingURL=getBytesSize.js.map